import script from "./KPISetTree.vue?vue&type=script&setup=true&lang=js"
export * from "./KPISetTree.vue?vue&type=script&setup=true&lang=js"

import "./KPISetTree.vue?vue&type=style&index=0&id=1f3a9754&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f3a9754"]])

export default __exports__